let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jhowT")).then(() => parcelRequire('cbm3L'));